import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  const token = localStorage.getItem('token');

  const fetchTestimonials = async () => {
    const res = await axios.get('http://localhost:5000/api/testimonials', {
      headers: { Authorization: `Bearer ${token}` }
    });
    setTestimonials(res.data);
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const handleApprove = async (id) => {
    await axios.put(`http://localhost:5000/api/testimonials/${id}/approve`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    fetchTestimonials();
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this testimonial?')) {
      await axios.delete(`http://localhost:5000/api/testimonials/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchTestimonials();
    }
  };

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">📋 Testimonial Review Panel</h2>

      <table className="table table-striped table-bordered">
        <thead className="table-dark">
          <tr>
            <th>Name</th>
            <th>Message</th>
            <th>Status</th>
            <th>Submitted</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {testimonials.map(t => (
            <tr key={t.id}>
              <td>{t.name}</td>
              <td>{t.message}</td>
              <td>
                {t.isApproved ? (
                  <span className="badge bg-success">Approved</span>
                ) : (
                  <span className="badge bg-warning text-dark">Pending</span>
                )}
              </td>
              <td>{new Date(t.created_at).toLocaleString()}</td>
              <td>
                {!t.isApproved && (
                  <button
                    onClick={() => handleApprove(t.id)}
                    className="btn btn-sm btn-success me-2"
                  >
                    Approve
                  </button>
                )}
                <button
                  onClick={() => handleDelete(t.id)}
                  className="btn btn-sm btn-danger"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminTestimonials;

